import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ConfigLoaderService } from './configloader.service';

export function load_settings(appLoadService: ConfigLoaderService) {
  return () => appLoadService.loadSettings();
}

@NgModule({
  imports: [HttpClientModule],
  providers: [
  ConfigLoaderService,
  { provide: APP_INITIALIZER, useFactory: load_settings, deps: [ConfigLoaderService], multi: true }
  ]
  })
export class ConfigLoaderModule { }
